<script lang="ts">
    import {Button, Input, Label, Modal, Select, Toggle} from "flowbite-svelte";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import dayjs from "dayjs";
    import {postTariff, updateTariff} from "$lib/calls/tariff";
    import {onMount} from "svelte";
    import {allUnits} from "$lib/stores/unit.js";
    import {unitQualifications} from "$lib/calls/qualification";

    export let currentTariff;
    export let extract = (tariff) => {}

    export let open = false;

    let qualifications = [];

    const saveTariff = async () => {
        if(currentTariff.id){
            await updateTariff(currentTariff)
        } else {
            extract(await postTariff(currentTariff))
        }
        open = false;

    }
    $: {
        if(currentTariff) {
            currentTariff.addedPercentageStandard = currentTariff.addedPercentageStandard ?? 0;
        }
    }

    onMount(async ()=> {
        unitQualifications(currentTariff.unitId).then(res => {
            qualifications = [...qualifications, ...res]
        })
    })


</script>
{#if currentTariff}
<Modal title={currentTariff?.name || 'Neuer Tarif'} bind:open>
    <form on:submit|preventDefault={saveTariff}>
        <div class="flex gap-3">
            <Label class="space-y-2 mb-3 flex-1">
                <span>Name</span>
                <Input required bind:value={currentTariff.name}/>
            </Label>
            <Label class="space-y-2 mb-3">
                <span>Sichtbar</span>
                <Toggle bind:checked={currentTariff.visible}/>
            </Label>
        </div>

        <div class="grid grid-cols-2 gap-3">
            <Label class="space-y-2">
                <span>Gültig ab</span>
                {#if currentTariff.id}
                    <div class="pt-2">
                        {dayjs(currentTariff.validFrom.value).format('DD.MM.YYYY')}
                    </div>
                {:else}
                    <Input required type="date" bind:value={currentTariff.validFrom}/>
                {/if}
            </Label>
            <Label class="space-y-2">
                <span>Unit</span>
                <Select required bind:value={currentTariff.unitId}>
                    {#each $allUnits as unit}
                        <option value={unit.id}>{unit.name}</option>
                    {/each}
                </Select>
            </Label>
            <Label class="space-y-2">
                <span>Stundenlohn</span>
                <Input required type="number" step=".01" bind:value={currentTariff.wagePerHour}/>
            </Label>
            <Label class="space-y-2">
                <span>Stunden pro Arbeitstag</span>
                <Input required type="number" step=".25" placeholder="7" bind:value={currentTariff.hoursPerDay}/>
            </Label>
            <Label class="space-y-2">
                <span>Arbeitstage pro Woche</span>
                <Input required type="number" step=".1" bind:value={currentTariff.workingDaysPerWeek}/>
            </Label>
            <Label class="space-y-2">
                <span>Stunden pro Monat</span>
                <div class="p-3">{(currentTariff.hoursPerDay * currentTariff.workingDaysPerWeek * 4.3).toFixed(0)}</div>
            </Label>
        </div>
        <h3 class="text-neutral-600 my-3 text-lg">Zuschläge</h3>
        <div class="grid grid-cols-2 gap-3">
            <Label class="space-y-2">
                <span>Standardzone</span>
                <Input required type="number" placeholder="0" bind:value={currentTariff.addedPercentageStandard}>
                    <div slot="right">%</div>
                </Input>
            </Label>
            <Label class="space-y-2">
                <span>Nachtzone</span>
                <Input required type="number" placeholder="20" bind:value={currentTariff.addedPercentageNight}>
                    <div slot="right">%</div>
                </Input>
            </Label>
            <Label class="space-y-2">
                <span>Sonntagszone</span>
                <Input required type="number" placeholder="50" bind:value={currentTariff.addedPercentageSunday}>
                    <div slot="right">%</div>
                </Input>
            </Label>
            <Label class="space-y-2">
                <span>Feiertagszone</span>
                <Input required type="number" placeholder="100" bind:value={currentTariff.addedPercentageHoliday}>
                    <div slot="right">%</div>
                </Input>
            </Label>
        </div>
        <h3 class="text-neutral-600 my-3 text-lg">A-Conto & Urlaub</h3>
        <div class="grid grid-cols-3 gap-3">
            <Label class="space-y-2">
                <span>A-Conto-Zahlung</span>
                <Input required type="number" step=".1" placeholder="1.5" bind:value={currentTariff.paymentOnAccount}/>
            </Label>
            <Label class="space-y-2">
                <span>Urlaubszuschlag</span>
                <Input type="number" step=".1" placeholder="0" bind:value={currentTariff.holidayPayPercent}/>
            </Label>
            <Label class="space-y-2">
                <span>Urlaubstage</span>
                <Input type="number" step=".5" placeholder="0" bind:value={currentTariff.ptoDays}/>
            </Label>
        </div>
        <h3 class="text-neutral-600 my-3 text-lg">Qualifikationen</h3>
        {#each currentTariff.qualifications as qualification}
            <div class="flex p-2 my-1 border rounded">
                <div class="flex-1 pt-1">{qualifications.find(x => x.id === qualification.qualificationId)?.title}</div>
                <RemoveButton value onClick={() => currentTariff.qualifications = currentTariff.qualifications.filter(x => x.id !== qualification.id)}/>
            </div>
        {/each}
        <div class="mt-3"></div>
        <Typeahead data={qualifications.filter(x => x.unitId === parseInt(currentTariff.unitId))}
                   displayProperty="title"
                   icon="search-outline"
                   required={currentTariff.qualifications.length < 1}
                   extract={quali => currentTariff.qualifications = [...currentTariff.qualifications, {qualificationId: quali.id}]} />
        <div class="grid mt-5">
            <Button class="place-self-end" type="submit">{currentTariff.id ? 'Update' : 'Anlegen'}</Button>
        </div>
    </form>
</Modal>
{/if}